
const PositionCalculator = {
    proportionalHeight(val) {
        // Verify if mobile
        var isMobile = window.innerWidth <= 769;

        var windowWitdh = window.innerWidth;
        var mult = (isMobile) ? 10 : 3;
        var vectorWidth = windowWitdh * mult;

        var objH = (isMobile) ? 105 : 556;
        var objW = (isMobile) ? 3600 : 5760;

        var svgRadius = objH / objW;
        var vectorHeight = vectorWidth * svgRadius;

        var pathPer = this.per(val, objH);
        var newVal = this.perVal(pathPer, vectorHeight);

        return newVal;
    },

    proportionalWidth(val) {
        // Verify if mobile
        var isMobile = window.innerWidth <= 769;

        var windowWitdh = window.innerWidth;
        var mult = (isMobile) ? 10 : 3;
        var vectorWidth = windowWitdh * mult;

        var objW = (isMobile) ? 3600 : 5760;

        var pathPer = this.per(val, objW);
        var newVal = this.perVal(pathPer, vectorWidth);

        return newVal;
    },

    per(num, amount) {
        return (num / amount) * 100;
    },

    perVal(per, amount) {
        return (per / 100) * amount;
    }
}

export { PositionCalculator };